export default __webpack_public_path__ + "static/media/download-new.3617c2cc.svg";